import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {CheckedOption} from "@app-shared/components/checkbox/checkbox-utils.service";
import {AreasOfLifePayload} from "@app-model/areas-of-life-payload";

@Component({
    selector: 'app-areas-of-life-checkbox',
    templateUrl: './areas-of-life-checkbox.component.html',
    styleUrls: ['./areas-of-life-checkbox.component.scss'],
    standalone: false
})
export class AreasOfLifeCheckboxComponent implements OnInit {
  @Input()
  subAreasOptions: CheckedOption[] = [];

  @Input()
  enableScroll? = true;

  @Input()
  attrLabel? = 'name';

  @Input()
  checkBoxAll? = false;

  @Input()
  boldSelectAll? = true;

  @Input()
  allSelect? = false;

  @Output()
  selectEvt = new EventEmitter<any>();

  @Input()
  allPhase? = 'Todos';

  @Input()
  onlySelected? = false;

  @Input()
  onlyView? = false;

  @Input()
  hideSelected? = false;

  @Input()
  onlySelectedOneOption? = false;

  @Input()
  readOnly? = false;

  @Input() enableSelectAllTopic: boolean = false;

  sanitizedAreasOfLifeData: AreasOfLifePayload[] = [];

  constructor() {}

  ngOnInit() {
    this.sanitizedAreasOfLifeData = this.saniziteGroupDataForCheckbox(this.subAreasOptions);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.sanitizedAreasOfLifeData = this.saniziteGroupDataForCheckbox(this.subAreasOptions);
  }

  saniziteGroupDataForCheckbox(data: any) {
    const groupedData = [];
    let currentGroup = {};

    data.forEach(item => {
      if (typeof item.option === 'string') {
        currentGroup = { separator: { ...item }, items: [] };
        groupedData.push(currentGroup);
      } else {
        //@ts-ignore
        currentGroup.items.push({ ...item });
      }
    });

    return groupedData;
  }

  label(obj) {
    return obj.option[this.attrLabel];
  }

  selectChecked(): any[] {
    const dataPayloadToEmit: any[] = [];
    this.sanitizedAreasOfLifeData
      .forEach((item: AreasOfLifePayload) => {
        item.items
          .forEach((subItem) => {
            if (subItem.checked){
              dataPayloadToEmit.push({
                checked: subItem.checked,
                companyId: undefined,
                hidden: subItem.hidden,
                option: {
                  lifeSubAreaId: subItem.option.lifeSubAreaId,
                  lifeSubAreaName: subItem.option.lifeSubAreaName
                },
                type: undefined
              })
            }
          });
      });
    return dataPayloadToEmit;
  }

  emitDataEvent(): void {
    this.selectEvt.emit(this.selectChecked());
  }

  selectItemsOnClick(data: any, allChecked: boolean) {
    const separator = data.separator;
    const items = data.items;
    if (separator && separator.separator) {
      items.forEach(item => {
        if (allChecked){
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
    }
  }

  updateAllComplete(data: AreasOfLifePayload) {
    const separator = data.separator;
    const items = data.items;

    separator.checked = items != null && items.every(t => t.checked);
  }

  allItemsIsChecked(data: AreasOfLifePayload): boolean {
    const separator = data.separator;
    const items = data.items;
    return items != null && items.every(t => t.checked);
  }
}

